import styled from "styled-components";
import ListOfUsers from "./page";

export default styled(ListOfUsers)``;
